import Api from '../api';
const { axios: api } = Api;
const PREFIX = 'customer';

const splitStudioLanguage = (payload = {}) => {
	const { language, ...body } = payload;

	return { language, body };
};

export const checkActive = async () => {
	const data = await api.get(`/${PREFIX}/check-active`);
	return { data: data.data };
};

export const getUserTokens = async () => {
	const data = await api.get(`/${PREFIX}/tokens`);
	return { data: data.data };
};

export const getUserProfileData = async () => {
	const data = await api.get(`/${PREFIX}/profile`);
	return { data: data.data };
};

export const updateUserProfileName = async (payload) => {
	const data = await api.patch(`/${PREFIX}/profile`, payload);
	return { data: data.data };
};

export const updateCustomerLanguage = async (payload) => {
	const data = await api.patch(`/${PREFIX}/language`, payload);
	return { data: data.data };
};

export const loadClientPersonData = async () => {
	const data = await api.get(`/${PREFIX}/customer-quiz-person`);
	return { data: data.data };
};

export const createFinalCustomerCharacter = async (payload) => {
	const { language, body } = splitStudioLanguage(payload);
	const data = await api.post(
		`/${PREFIX}/create-final-customer-character`,
		body,
		{
			params: language ? { language } : undefined,
		},
	);
	return { data: data.data };
};

export const generateStudioPortrait = async (payload) => {
	const { language, body } = splitStudioLanguage(payload);
	const data = await api.post(`/${PREFIX}/studio/generate-portrait`, body, {
		params: language ? { language } : undefined,
	});
	return { data: data.data };
};
